// extracted by mini-css-extract-plugin
export var compactFilters = "_c5-4";
export var detailImage = "_c5-1";
export var dropdownContainer = "_c5-2";
export var imageContainer = "_c5-0";
export var selectedCard = "_c5-3";